import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";
import DataTable from "@/components/DataTable";
import { ReactRender } from "@/components/ReactRender";
import ChipStatus from "@/components/ChipStatus";
import HasPermission from "@/components/commons/HasPermission";
import { useTranslation } from "@/langs/useTranslation";
import { getTriggeredDeviceList } from "@/apis/apiCollection";
import { formatDate } from "./datetimeHandlers";
import { renderAlarmPolicy } from "./utils";

export const DashboardAlarmDeviceListDatatable = React.forwardRef(
  (
    {
      className,
      style,
      footer,
      children,
      onCheckAll,
      onLoaded,
      onReset,
      getSearchParams
    },
    ref
  ) => {
    const { t } = useTranslation();
    const history = useHistory();

    const toDetail = e => {
      e.preventDefault();
      const url = new URL(e.target.href);
      history.push(url.pathname);
    };

    const columns = [
      {
        name: "deviceSerialNumber",
        data: "deviceSerialNumber",
        title: t({ defaultMessage: "设备SN" }),
        searchable: true,
        createdCell: (td, data, rowData) => {
          ReactRender(
            <HasPermission permission="Device Monitoring Detail">
              {yes =>
                yes ? (
                  <a
                    href={`/device-list/device-detail/${rowData.deviceId}/${
                      rowData.os_type || "android"
                    }`}
                    onClick={toDetail}
                  >
                    {data}
                  </a>
                ) : (
                  data
                )
              }
            </HasPermission>,
            td
          );
        }
      },
      {
        name: "deviceName",
        data: "deviceName",
        orderable: false,
        title: t({ defaultMessage: "设备名称" })
      },
      {
        name: "deviceDetail",
        data: "deviceDetail",
        orderable: false,
        title: t({ defaultMessage: "描述" })
      },
      {
        name: "groups",
        data: row => {
          return row.groups.map(item => item.name).join(", ");
        },
        title: `${t({ defaultMessage: "门店" })}`
      },
      {
        data: "alarmTemplateName",
        title: t({ defaultMessage: "报警模板名称" })
      },
      {
        data: "alarmPolicyOptionName",
        title: `${t({ defaultMessage: "报警条件" })}`,
        render: (data, type, row) => {
          return renderAlarmPolicy(data, row);
        }
      },
      {
        data: "triggerValue",
        title: t({ defaultMessage: "触发值" }),
        className: "center"
        // createdCell: (td, data) => {
        //   ReactRender(
        //     <Typography variant="body2" color="primary">
        //       {data}
        //     </Typography>,
        //     td
        //   );
        // }
      },
      {
        data: "triggerNum",
        title: t({ defaultMessage: "触发次数" }),
        className: "center"
        // createdCell: (td, data) => {
        //   ReactRender(
        //     <Typography variant="body2" color="primary">
        //       {data}
        //     </Typography>,
        //     td
        //   );
        // }
      },
      {
        data: "triggerDate",
        title: t({ defaultMessage: "最后触发时间" }),
        render: data => {
          return formatDate(data);
        }
      },
      {
        data: null,
        title: t({ defaultMessage: "操作" }),
        className: "center",
        searchable: false,
        orderable: false,
        createdCell: (td, data, row) => {
          ReactRender(
            <HasPermission permission="alarm_history_alarm_delete">
              <Button size="small" color="primary" onClick={() => onReset(row)}>
                {t({ defaultMessage: "重置" })}
              </Button>
              {/* <Button
                size="small"
                color="secondary"
                onClick={() => onDelete(row)}
              >
                {t({ defaultMessage: "删除" })}
              </Button> */}
            </HasPermission>,
            td
          );
        }
      }
    ];

    const ajax = (data, callback) => {
      return getTriggeredDeviceList({
        // ...data,
        ...getSearchParams(),
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.triggeredDevices,
          draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        options={{ pageLength: 10 }}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        footer={footer}
        showCheckAll={false}
        onCheckAll={onCheckAll}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
